import { useCallback } from "react";
import { AppConstants, PlatformApi } from "../../configs";
import { AxiosAuth } from "../../core";
import { ApiResponse } from "../../models";
import {
  CallTranscriptionAccessUrlResponseModel,
  CallTranscriptionResponseModel,
} from "../../models/api/callTranscription";

export function useFunctionalityCallTranscription() {
  const LoadByCallId = useCallback(async (callId: string) => {
    const url = PlatformApi.CallTranscription.GetByCall(callId);
    try {
      const res = await AxiosAuth.get<ApiResponse<CallTranscriptionResponseModel>>(url);
      if ((res.status = AppConstants.Api.StatusOK)) {
        return Promise.resolve(res.data.data);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);

  const LoadAccessUrl = useCallback(
    async (
      callTranscriptionId: string,
      asDownload?: boolean,
      expiresInMinutes?: number
    ) => {
      const url = PlatformApi.CallTranscription.GetAccessUrl(
        callTranscriptionId,
        asDownload,
        expiresInMinutes
      );
      try {
        const res = await AxiosAuth.get<ApiResponse<CallTranscriptionAccessUrlResponseModel>>(url);
        if ((res.status = AppConstants.Api.StatusOK)) {
          return Promise.resolve(res.data.data);
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  return {
    LoadByCallId,
    LoadAccessUrl,
  };
}
